<template>
  <div class="page" :style="{ height: fixedHeight + 'px' }">
    <div class="flex">
      <el-button style="float: right;margin-left: 10px;" type="warning" @click="handleBackClick" size="small">返回</el-button>
      <el-button style="float: right" type="warning" plain @click="handleSubmitClick" size="small">提交</el-button>
    </div>
    <!-- 表格 -->
    <div class="tableView">
      <el-table :data="staffInfo" style="width: 100%;">
        <el-table-column prop="shopName" label="门店">
        </el-table-column>
        <el-table-column prop="position" label="职位">
        </el-table-column>
        <el-table-column prop="real_name" label="姓名">
        </el-table-column>
        <el-table-column prop="sex" label="性别">
        </el-table-column>
        <el-table-column prop="user_no" label="员工编号">
        </el-table-column>
        <el-table-column prop="user_mobile" label="手机号">
        </el-table-column>
        <el-table-column prop="user_name" label="登录账号">
        </el-table-column>
        <el-table-column prop="introduce" label="介绍">
          <template slot-scope="scope">{{ scope.row.introduce ? scope.row.introduce : '--' }}</template>
        </el-table-column>
        <el-table-column prop="status" label="状态">
          <template slot-scope="scope">{{ scope.row.status == 1 ? '在职' : '离职' }}</template>
        </el-table-column>
      </el-table>
      <div class="pageTR">
        <div class="dataView" v-for="(item, index) in states" :key="index">
          <div class="dataTab" :class="state == item.title ? 'activeData' : ''" @click="tab(index, item)">
            {{ item.title }}
          </div>
        </div>
      </div>
    </div>
    <el-tree class="tree" :data="StaffsList" :props="defaultProps" show-checkbox node-key="code" ref="rightsTree"
      :current-node-key="roleSelected" default-expand-all :default-checked-keys="roleArray"
      :render-content="renderContent">
      <!-- :render-content="renderContent" 图标 -->
    </el-tree>
    <div class="footer">
     
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tree: [],//系统树
      staffInfo: [],//员工信息
      fixedHeight: '',
      stateList: { title: "o2o", code: "o2o" }, //选中的系统
      state: "o2o", //状态
      states: [

      ], //状态列表
      StaffsList: [], //员工拥有权限树
      staff_info: this.$route.query.staff_info,
      defaultProps: {
        children: "childs",
        label: "title",
        disabled(data, node) { // 角色应有的权限 不可改
          return data.is_role == true
        }
      },
      roleArrayItem: [],
      roleArray: [],
      roleSelected: "",
      RoleParams: [],//提交选中的数组
      // 设置图标
      renderContent: function (h, { node, data, store }) {
        let addElement = arguments[0];
        if (data.menu_type == 3) {
          return addElement('span', [
            addElement('i', { class: "el-icon-mouse" }),
            addElement('span', "    "),
            addElement('span', arguments[1].node.label)
          ]);
        } else if (data.menu_type == 2) {
          return addElement('span', [
            addElement('i', { class: "el-icon-s-order" }),
            addElement('span', "    "),
            addElement('span', arguments[1].node.label)
          ]);
        } else if (data.menu_type == 1) {
          return addElement('span', [
            addElement('i', { class: "el-icon-s-tools" }),
            addElement('span', "    "),
            addElement('span', arguments[1].node.label)
          ]);
        }
      }
    }
  },
  mounted() {
    this.getsystemList()
    let arr = this.$route.query.row
    this.staffInfo.push(
      {
        shopName: arr.shopName,
        position: arr.archives_info.position,
        real_name: arr.basic_info.real_name,
        sex: arr.archives_info.sex,
        user_no: arr.basic_info.user_no,
        user_mobile: arr.basic_info.user_mobile,
        user_name: arr.basic_info.user_name,
        status: arr.status,
        introduce: arr.archives_info.introduce

      })
    this.fixedHeight = document.documentElement.clientHeight - 76;
    this.getStaffRights()
  },
  methods: {
    getsystemList() {
      this.$http.get(process.env.VUE_APP_zichan + '/api/SystemRights/system/list').then(res => {
        if (res.code == 0) {
          this.states = res.data

        }
      })
    },
    // 返回
    handleBackClick() {
      this.$router.go(-1);
    },
    handleSelectionChange() {

    },
    tab(index, item) {

      this.stateList = item;
      this.state = item.title;
      this.StaffsList = [];
      this.getStaffRights();
    },
    // 获取员工权限树
    getStaffRights() {
      let params = {
        staffId: this.staff_info.id,
      }
      this.$http.get(process.env.VUE_APP_zichan + '/api/SystemRights/staff/rightsTree', params).then(res => {
        if (res.code == 0) {
          if (this.state == 'o2o') {
            this.tree = res.data[0]
          } else if (this.state == 'OA') {
            this.tree = res.data[2]
          } else if (this.state == 'app后台') {
            this.tree = res.data[3]
          }
          const circulation = (roleTreeArray) => {
            roleTreeArray.forEach((item) => {
              if (item.is_role == false && item.is_check) {
                this.roleArray.push(item.code);
              }
              if (item.childs && item.childs.length) {
                circulation(item.childs);
              }
            });
          };
          //把数列表拿到
          this.StaffsList = this.tree.rights_info;
          //递归判断is_check为true 就添加到默认勾选中
          circulation(this.StaffsList);
        }
      })
    },
    // 提交
    handleSubmitClick() {
      let parentList = this.$refs.rightsTree.getHalfCheckedNodes()
    let chirenldList = this.$refs.rightsTree.getCheckedNodes()
    let arr=[...parentList,...chirenldList];
    this.RoleParams=arr
      this.$confirm("确定提交?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let params = {
          menu_list: this.RoleParams,
          staff_info: this.staff_info,
          system_info: this.stateList
        };
        this.$http
          .post(process.env.VUE_APP_zichan + "/api/SystemRights/staff/customRights", params)
          .then((res) => {
            if (res.code == 0) {
              this.$message({
                type: "success",
                message: "更改成功",
              });
              this.getStaffRights();
              this.$router.go(-1);
            }
          })
      })

    }

  }
}
</script>
<style lang="scss" scoped>
.page {
  display: flex;
  flex-direction: column;

  .tableTitle {
    margin: 20px 0;
    border-left: 5px solid #F5882A;
  }

  // .tree{
  //   width: 100%;
  //   height: 100%;
  //   background-color: #fff;
  // }
  .pageTR {
    width: 200px;
    margin-right: 46px;
    display: flex;
    justify-content: space-around;
    align-items: center;

    .dataView {
      // display: flex;
      // justify-content: space-around;

      font-size: 15px;
      font-weight: bold;

      .dataTab {
        line-height: 32px;
        text-align: center;
        cursor: pointer;
      }

      .activeData {
        color: #f5882a;
        border-bottom: 2px solid #f5882a;
      }
    }
  }

  .footer {
    margin: 20px auto;
  }
}
</style>